/* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useRef } from 'react';
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  SvgIcon, Button, IconButton, ClickAwayListener
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { withStyles } from 'tss-react/mui';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import Tooltip from 'src/components/Tooltip';
import helpers from 'src/helpers';

import { ReactComponent as SelectDownIcon } from 'src/assets/images/select-down.svg';
import { ReactComponent as FilterIcon } from 'src/assets/images/filter.svg';

import filterStyle from 'src/components/View/Header/filter.style';

import ModalDialogVideo from 'src/components/ModalDialogVideo/index';

function Filter({
  classes,
  children,
  filterValues,
  onClickApply,
  onClickCancel,
  openDropDown,
  setOpenDropDown,
  showVideo,
  videoTooltip,
  videoURL,
}) {
  const elRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const getFiltersApply = () => {
    // Keys that should never count toward the badge (UI controls, not filters)
    const excludedKeys = new Set([
      'eventsIncludeMode',
      'eventsIncludeHosts',
      'eventsIncludeGuests',
      'eventsExcludeMode',
      'eventsExcludeHosts',
      'eventsExcludeGuests',
      'locationMode',
      'receivedTextMode',
      'sentTextMode',
    ]);
    // Keys where the default string value should not count as an active filter
    const defaultValues = { phone1Valid: 'any', phone1Textable: 'any' };
    let count = 0;
    Object.keys(filterValues).forEach((key) => {
      if (excludedKeys.has(key)) return;
      if (key in defaultValues && filterValues[key] === defaultValues[key]) return;
      if (!helpers.isEmpty(filterValues[key])) {
        count++;
      }
    });
    return count;
  };

  const filtersApply = getFiltersApply();

  const handleClickAnywhere = () => {
    setOpenDropDown(false);
  };

  const handleClick = () => {
    setOpenDropDown(!openDropDown);
  };

  const handleClickApply = () => {
    onClickApply();
  };

  const handleClickCancel = () => {
    onClickCancel();
    setOpenDropDown(false);
  };

  return (
    <>
      <ClickAwayListener onClickAway={handleClickAnywhere}>
        <div
          className={`${classes.root} withBtn inner`}
          ref={elRef}
        >
          <div
            className="divBtn"
            onClick={handleClick}
          >
            <div className="icon">
              <SvgIcon
                className="svgIcon"
                component={FilterIcon}
                viewBox="0 0 24 24"
              />
            </div>
            <div className="input">
              Filter By
              {helpers.transform.toInt10(filtersApply) > 0 && (
              <span className="filterCount">
                {filtersApply}
              </span>
              )}
            </div>
            <div className="iconRight">
              <SvgIcon
                className="svgIcon"
                component={SelectDownIcon}
                viewBox="0 0 24 24"
              />
            </div>
          </div>
          {openDropDown && (
          <div className={classes.innerFieldDropDown}>
            <Grid
              className="buttonLine"
              container
              spacing={0}
            >
              {showVideo
              && (
                <Grid>
                  <Tooltip
                    title={videoTooltip}
                    placement="left-start"
                  >
                    <IconButton
                      // className="buttonLine"
                      className="videoIcon"
                      color="secondary"
                      // target="_blank"
                      // href={videoURL}
                      // rel="noopener noreferrer"
                      // onClick={(e) => {
                      //   e.stopPropagation();
                      // }}
                      onClick={handleOpen}
                      size="large"
                    >
                      <SvgIcon fontSize="large">
                        <OndemandVideoIcon />
                      </SvgIcon>
                    </IconButton>
                  </Tooltip>
                </Grid>
              )}
              {/* <div className="buttonLine"> */}
              {/* <div> */}
              <Grid>
                <Button
                  className="cancel"
                  onClick={handleClickCancel}
                >
                  Clear all filters
                </Button>
                <Button
                  onClick={handleClickApply}
                >
                  Apply
                </Button>
                {/* </div> */}
              </Grid>
            </Grid>
            <div className="formBox">
              {children}
            </div>
          </div>
          )}
        </div>
      </ClickAwayListener>
      <ModalDialogVideo
        onClose={handleClose}
        isVisible={open}
        videosrc={videoURL}
        title={videoTooltip}
        largeModal
      />
    </>
  );
}

Filter.propTypes = {
  classes: PropTypes.object.isRequired,
  onClickApply: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func.isRequired,
  filterValues: PropTypes.object.isRequired,
  children: PropTypes.node,
  openDropDown: PropTypes.bool,
  setOpenDropDown: PropTypes.func,
  showVideo: PropTypes.bool,
  videoTooltip: PropTypes.string,
  videoURL: PropTypes.string,
};
Filter.defaultProps = {
  children: null,
  openDropDown: false,
  setOpenDropDown: () => { },
  showVideo: false,
  videoTooltip: '',
  videoURL: '',
};

export default withStyles(Filter, filterStyle, { withTheme: true });
